import { matrizDe, type VariantFamily } from './prendas';

/**
 * Una prenda en tallas por colores, con una casilla para teclear en cada
 * talla. Lo de cada casilla es del **insumo** de esa talla: el conteo y la
 * orden de compra siguen guardando por insumo, como antes; la matriz solo
 * cambia cómo se teclea.
 *
 * No enseña el stock: el conteo se hace a ciegas (ver `Conteo.tsx`), y quien
 * pide lo mira en su propia columna.
 */
export function MatrizParaTeclear({
  familia,
  valores,
  alTeclear,
  rotulo,
  placeholderDe,
}: {
  familia: VariantFamily;
  /** Lo tecleado, por insumo. */
  valores: Readonly<Record<string, string>>;
  alTeclear: (supplyId: string, texto: string) => void;
  /** Lo que se lee antes de cada casilla para un lector de pantalla. */
  rotulo: string;
  placeholderDe?: (supplyId: string) => string | undefined;
}) {
  const matriz = matrizDe(familia, []);

  return (
    <div className="tabla-envoltura prenda__matriz">
      <table>
        <thead>
          <tr>
            <th>{matriz.ejeFilas}</th>
            {matriz.columnas.map((columna) => (
              <th key={columna}>{matriz.ejeColumnas === null ? '' : columna}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {matriz.filas.map((fila, indiceFila) => (
            <tr key={fila}>
              <td>
                <strong>{fila}</strong>
              </td>
              {matriz.casillas[indiceFila]!.map((casilla, indiceColumna) => {
                const supplyId = casilla?.supplyId ?? null;
                return (
                  <td key={matriz.columnas[indiceColumna]}>
                    {supplyId === null ? (
                      <span className="apagado">—</span>
                    ) : (
                      <input
                        className="prenda__entrada"
                        inputMode="decimal"
                        placeholder={placeholderDe?.(supplyId) ?? '0'}
                        aria-label={`${rotulo} ${familia.name} ${fila} ${matriz.columnas[indiceColumna] ?? ''}`.trim()}
                        value={valores[supplyId] ?? ''}
                        onChange={(evento) => alTeclear(supplyId, evento.target.value)}
                      />
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
